import React from "react";
import { Labeled, ShowProps, TextField } from "react-admin";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { availableOnlySuperAdminAndAdminAndFinance } from "utils/tools";
import StatusField from "components/StatusField";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
  },
  table: {
    minWidth: 650,
  },
});

const Summary = (props: ShowProps) => {
  const classes = useStyles();

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12} style={GridinRowsWithSpace}>
        <Typography variant="h6">Company Detail</Typography>

        {availableOnlySuperAdminAndAdminAndFinance() && (
          <Button
            className={classes.summaryButton}
            variant="contained"
            color="primary"
            component={Link}
            to={{
              pathname: `/companies/${Number(props.id)}`,
            }}
            startIcon={<EditIcon />}
          >
            Edit
          </Button>
        )}
      </Grid>

      <Grid item xs={12}>
        <Labeled source="Id">
          <TextField source="id" />
        </Labeled>
      </Grid>

      <Grid item xs={12}>
        <Labeled source="Name">
          <TextField source="name" />
        </Labeled>
      </Grid>

      <Grid item xs={3}>
        <Labeled source="Email">
          <TextField source="user.email" />
        </Labeled>
      </Grid>
      <Grid item xs={3}>
        <Labeled source="Mobile">
          <TextField source="mobile" />
        </Labeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={3}>
        <Labeled source="Status">
          <StatusField source="status" />
        </Labeled>
      </Grid>

      <Grid item xs={3}>
        <Labeled source="Register Date">
          <CustomDateField source="createdAt" emptyText="-" isDateTime />
        </Labeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={3}>
        <Labeled source="Va Number">
          <TextField source="vaNumber" emptyText="-" />
        </Labeled>
      </Grid>
      <Grid item xs={3}>
        <Labeled source="Mbc Code">
          <TextField source="user.mbcCustomerId" emptyText="-" />
        </Labeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={12}>
        <Typography variant="h6">Address Info</Typography>
      </Grid>

      <Grid item xs={12}>
        <Labeled source="address">
          <TextField source="address" emptyText="-" />
        </Labeled>
      </Grid>

      <Grid item xs={3}>
        <Labeled source="Block No.">
          <TextField source="blockNumber" emptyText="-" />
        </Labeled>
      </Grid>

      <Grid item xs={3}>
        <Labeled source="Unit No.">
          <TextField source="unit" emptyText="-" />
        </Labeled>
      </Grid>
      <Grid item xs={6}></Grid>

      <Grid item xs={3}>
        <Labeled source="Building Name">
          <TextField source="building" emptyText="-" />
        </Labeled>
      </Grid>

      <Grid item xs={3}>
        <Labeled source="postalCode">
          <TextField source="postalCode" emptyText="-" />
        </Labeled>
      </Grid>
    </SanitizedGrid>
  );
};

export default Summary;
